module.exports = __webpack_public_path__ + "img/solicitudes.7797d191.svg";